<!-- TODO: Add #CMS Translations -->
<div class="h-full flex flex-col">
    <div class="mt-2h flex flex-col gap-2 pb-10 items-center">
        <p class="text-2xl/7 font-bold text-[#333333] text-center">{{ cmsLabels.stellar.signIn.submitOtp.enterSecurityCode }}</p>
        <!-- Todo: Tim: may need to revisit this to interpolate the phone number into the message -->
        <p class="text-base text-[#737373] text-center">{{ getPhoneLabel(cmsLabels.stellar.signIn.submitOtp.sentSecurityCodeSubtitle, displayPhoneNumber) }}</p> 
    </div>
    <div class="flex flex-col items-center">
        <p class="text-xs text-[#737373] text-center">{{ cmsLabels.stellar.signIn.submitOtp.codeWillBeValid }}</p>
        <app-otp-input #otpInputComponent (otpFormSubmitEvent)="submitOtp($event)" class="mt-4 mb-6 w-full" [size]='6'></app-otp-input>
        <button [disabled]="isResetButtonDisabled" (click)="requestNewOtpCode()" class="text-[#e42313] font-['Roboto'] font-bold border-none bg-white" [ngClass]="{'text-gray-500': isResetButtonDisabled}">{{ cmsLabels.stellar.signIn.submitOtp.sendNewCode }}</button>
        <app-countdown-timer [timerClickSubject]="timerClickSubject" [initialTime]="initialCountdownInSeconds"></app-countdown-timer>
    </div>
</div>
